import axios from 'axios'

export const leapsMeditationService = ({
  getLeapsMeditationList (token) {
    return axios.get('/api/leaps/meditations', {headers: {'Authorization': 'Bearer ' + token}})
  },
  createLeapsMeditation (token, formDataObj) {
    return axios.post('/api/leaps/meditations/create', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateLeapsMeditation (token, formDataObj) {
    return axios.put('/api/leaps/meditations/put', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  deleteLeapsMeditation (token, meditationLibraryId) {
    return axios.delete('/api/leaps/meditations/delete?meditationId=' + meditationLibraryId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  deleteMeditationVttFile (token, meditationLibraryId) {
    return axios.delete('/api/leaps/meditations/removevttfile?MeditationLibraryId=' + meditationLibraryId, {headers: {'Authorization': 'Bearer ' + token}})
  }
})



// WEBPACK FOOTER //
// ./src/server-util/leaps-meditation-service.js